// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @typescript-eslint/no-explicit-any,   @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HeadingCellWrapper = styled.div<{ first?: any; last?: any }>`
	display: inline-block;
	padding: 0;
	padding-left: ${
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(props: any) => (props.first ? gridSize : gridSize / 2)
	}px;
	padding-right: ${
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(props: any) => (props.last ? gridSize : gridSize / 2)
	}px;
`;

// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @typescript-eslint/no-explicit-any,   @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CellWrapper = styled.div<{ first?: any; last?: any }>`
	padding: ${token('space.100', '8px')};
	padding-left: ${
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(props: any) => (props.first ? gridSize : gridSize / 2)
	}px;
	padding-right: ${
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(props: any) => (props.last ? gridSize : gridSize / 2)
	}px;
`;
